import DataTypeUtils from '@gp/utils/DataTypeUtils';
import {
  toFirstUpperCase,
  getFormatNumPlus,
  getFormatPercentPlus,
  getPureEmptyValue,
} from '@gp/utils/common';
import { ECHART_COLOR } from '@gp/constants/const';
import { BASE_BAR_SERIES_OPTION } from '@gp/constants/echarts';

type IType = 'actual' | 'target';

const TOTAL_FIELD_NAME = 'total';
const ACTUAL_FIELD_NAME = 'actual';
const TARGET_FIELD_NAME = 'target';

const DOMAIN_NAMES = {
  revenue: 'Gross Revenue YTM',
  profit: 'Net Profit YTM',
};

const getBarChartOptionData = (data: any): any => {
  // const projectNames: string[] = [];
  const series: IEChartSeriesOption[] = [];
  /* const sources: {
    type: IType;
    [key: string]: string;
  }[] = [
    {
      type: ACTUAL_FIELD_NAME,
    },
    {
      type: TARGET_FIELD_NAME,
    },
  ]; */
  const optionData: {
    xAxis: {
      data: IType[];
    };
    series: IEChartSeriesOption[];
    /* dataset: {
      dimensions: string[];
      source: { type: IType; [key: string]: string }[];
    }; */
  } = {
    xAxis: {
      data: [ACTUAL_FIELD_NAME, TARGET_FIELD_NAME],
    },
    series: [],
    /* dataset: {
      dimensions: [],
      source: [],
    }, */
  };
  // let newData;

  if (!Array.isArray(data)) return optionData;

  /* newData = data?.filter(
    (dataItem: any) => dataItem?.name !== TOTAL_FIELD_NAME,
  ); */
  const totalData = data?.filter(
    (dataItem: any) => dataItem?.name === TOTAL_FIELD_NAME,
  )?.[0] || null;

  const totalDataList: { value: string | undefined, data: { [key: string]: string } | undefined }[] = [];
  for (const dataItem of data) {
    const projectName = dataItem?.name;
    const dataList: { value: string | undefined, data: { [key: string]: string } | undefined }[] = [];
    for (let j = 0; j < data?.length; j++) {
      const k: { [key: string]: string } = data?.[j];
      if (projectName === k?.name) {
        [ACTUAL_FIELD_NAME, TARGET_FIELD_NAME].forEach((item) => {
          if (k?.name === TOTAL_FIELD_NAME) {
            totalDataList.push({
              value: '0',
              data: {
                [TOTAL_FIELD_NAME]: totalData?.[item] || undefined,
              },
            });
          } else {
            dataList.push({
              value: k?.[item] || undefined,
              data: undefined,
            });
          }
        });
        break;
      }
    }
    // projectNames.push(projectName);
    projectName !== TOTAL_FIELD_NAME && series.push({
      ...BASE_BAR_SERIES_OPTION,
      barWidth: BASE_BAR_SERIES_OPTION?.barMaxWidth,
      name: projectName,
      stack: 'total',
      barGap: 0,
      data: dataList,
    });
    /* sources[0] = {
      ...sources?.[0],
      [projectName]: dataItem?.[ACTUAL_FIELD_NAME],
    };
    sources[1] = {
      ...sources?.[1],
      [projectName]: dataItem?.[TARGET_FIELD_NAME],
    }; */
  }
  series.push({
    ...BASE_BAR_SERIES_OPTION,
    barWidth: BASE_BAR_SERIES_OPTION?.barMaxWidth,
    name: '',
    stack: 'total',
    barGap: 0,
    data: totalDataList,
    label: {
      ...BASE_BAR_SERIES_OPTION.label,
      show: true,
      formatter: (params: any) => {
        const { data } = params;
        const result = getFormatNumPlus(data?.data?.total);
        return getPureEmptyValue(result);
      },
    },
  });

  // const totalData = data?.find((item) => item?.name === TOTAL_FIELD_NAME);
  // if (totalData) {
  //   series[series?.length - 1] = {
  //     ...series[series?.length - 1],
  //     label: {
  //       show: true,
  //       position: 'top',
  //       color: '#000',
  //       // @ts-ignore
  //       formatter: (params: any) => {
  //         if (params?.name === ACTUAL_FIELD_NAME)
  //           return getFormatNumPlus(totalData?.[ACTUAL_FIELD_NAME]);
  //         if (params?.name === TARGET_FIELD_NAME)
  //           return getFormatNumPlus(totalData?.[TARGET_FIELD_NAME]);
  //         return '';
  //       },
  //     },
  //   };
  // }

  optionData.series = series;
  // optionData.dataset.dimensions = ['type', ...projectNames];
  // optionData.dataset.source = sources;

  return optionData;
};

const legendFormatter = (name: string): string => {
  return toFirstUpperCase(name);
};

const axisLabelOfXAxisFormatter = (
  domain: 'revenue' | 'profit',
  name: IType,
): string => {
  const domainName = toFirstUpperCase(domain);

  return name === ACTUAL_FIELD_NAME
    ? DOMAIN_NAMES[domain]
    : `${domainName} Target`;
};

const axisLabelOfYAxisFormatter = (payload: any): string => {
  return getFormatNumPlus(payload, 2, false);
};

// tooltip浮窗内容
const tootipFormatter = (
  domain: 'revenue' | 'profit',
  params: IEChartDataEntity[],
) => {
  // 第一列,系列名称那一列
  const serieNameHtmlStrs: string[] = [];
  // 第二列,实际发生值那一列
  const actualHtmlStrs: string[] = [];
  // 第三列,预估值那一列
  const targetHtmlStrs: string[] = [];
  // 第四列,完成比那一列
  const completionHtmlStrs: string[] = [];
  // 加总的数据
  let totalParam: IEChartDataEntity = {
    name: TOTAL_FIELD_NAME,
    [ACTUAL_FIELD_NAME]: '0',
    [TARGET_FIELD_NAME]: '0',
    completion: '0',
  };
  let paramsWithoutTotal;

  if (DataTypeUtils.isArray(params)) {
    // 加总的数据
    const totalParamIndex = params.findIndex(
      (param) => param?.name === TOTAL_FIELD_NAME,
    );
    if (totalParamIndex !== -1) {
      totalParam = params[totalParamIndex];
    }
    paramsWithoutTotal = params?.filter(
      (param) => param?.name !== TOTAL_FIELD_NAME,
    );
    for (let i = 0; i < paramsWithoutTotal.length; i++) {
      const param = paramsWithoutTotal[i];
      const serieName = param?.name || '-';
      const serieColor =
        ECHART_COLOR[i] || ECHART_COLOR[ECHART_COLOR.length - 1];
      const actual = getFormatNumPlus(param?.[ACTUAL_FIELD_NAME]);
      const target = getFormatNumPlus(param?.[TARGET_FIELD_NAME]);
      const completion = getFormatPercentPlus(param?.completion, 1);
      const serieNameHtmlStr = `
        <div style="display: flex; flex-wrap: nowrap; align-items: center; margin-top: 6px;">
          <span class='general-circular-dot' style="background-color: ${serieColor};"></span>
          <div class='general-item body-text' style="margin: 0px;">${serieName}</div>
        </div>
      `;
      const actualHtmlStr = `<div class='general-item body-num' style="text-align: right;">${actual}</div>`;
      const targetHtmlStr = `<div class='general-item body-num' style=" text-align: right;">${target}</div>`;
      const completionHtmlStr = `<div class='general-item body-num' style=" text-align: right;">${completion}</div>`;
      serieNameHtmlStrs.push(serieNameHtmlStr);
      actualHtmlStrs.push(actualHtmlStr);
      targetHtmlStrs.push(targetHtmlStr);
      completionHtmlStrs.push(completionHtmlStr);
    }
  }

  const serieNameHtmlStr = serieNameHtmlStrs.join('');
  const actualHtmlStr = actualHtmlStrs.join('');
  const targetHtmlStr = targetHtmlStrs.join('');
  const completionHtmlStr = completionHtmlStrs.join('');

  const htmlStr = `
  <div class="echart-tooltip-style-content">
  <div style="display: flex;">
    <div style="margin-right: 20px">
      <div class="general-item header-title" style="margin-top: 0px;">
        Category
      </div>
      <div class="general-item" style="height: auto; margin-top: 0px;">
        <div style="display: flex; flex-wrap: nowrap; align-items: center; margin-top: 6px;">
          <div class="general-item  body-text" style="margin: 0px;">
            Total
          </div>
        </div>
        ${serieNameHtmlStr}
      </div>
    </div>
    <div style="margin-right: 20px">
      <div
        class="general-item header-title"
        style="margin-top: 0px; text-align: right;"
      >
        ${DOMAIN_NAMES[domain]}
      </div>
      <div class="general-item" style="height: auto; margin-top: 0px;">
        <div class="general-item body-num" style="text-align: right;">
          ${getFormatNumPlus(totalParam?.[ACTUAL_FIELD_NAME])}
        </div>
        ${actualHtmlStr}
      </div>
    </div>
    <div style="margin-right: 20px">
      <div
        class="general-item header-title"
        style="margin-top: 0px; text-align: right;"
      >
        Target
      </div>
      <div class="general-item" style="height: auto; margin-top: 0px;">
        <div class="general-item body-num " style="text-align: right;">
          ${getFormatNumPlus(totalParam?.[TARGET_FIELD_NAME])}
        </div>
        ${targetHtmlStr}
      </div>
    </div>
    <div style="">
      <div
        class="general-item header-title"
        style="margin-top: 0px; text-align: right;"
      >
        Completion%
      </div>
      <div class="general-item" style="height: auto; margin-top: 0px;">
        <div class="general-item body-num" style="text-align: right;">
          ${Number.isNaN(
    Number.parseFloat(totalParam?.completion as string),
  )
      ? '0'
      : getFormatPercentPlus(totalParam?.completion, 1)}
        </div>
        ${completionHtmlStr}
      </div>
    </div>
  </div>
</div>
  `;
  return htmlStr;
};

export {
  getBarChartOptionData,
  legendFormatter,
  axisLabelOfXAxisFormatter,
  axisLabelOfYAxisFormatter,
  tootipFormatter,
};
